<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="query.type==1?filterOptions:filterOptions1" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <!-- <div class="right">
          <div class="search">
            <input type="text" v-model="query.keyWord"  />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div> -->
      </div>

    <div style="margin-bottom: 15px; width: 20%;">
      <el-tabs v-model="query.type" class="tabBox" @tab-click="tabClick">
            <el-tab-pane v-for="item in CounterStockArray" :key="item.id" :name="item.id + ''">
              <template slot="label">
                <el-badge :value="item.count" :max="99" class="item">
                  <span style="margin: 0 10px"> {{ item.name }} </span>
                </el-badge>
              </template>
            </el-tab-pane>
          </el-tabs>
    </div>
    


      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="{ background: '#e4e4e4' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column prop="deptName" width="120" label="科室" show-overflow-tooltip></el-table-column>
        <el-table-column prop="intelligenceCounterName" width="150" label="智能柜" show-overflow-tooltip></el-table-column>
        <el-table-column prop="rfid" width="150" v-if="query.type==1" :key="'Rfid'" label="Rfid" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
        <el-table-column prop="productName" width="150" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productRegistCertName" width="150" label="注册证名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" width="150" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" width="150" label="生产厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stockQuantity" width="100" label="数量"></el-table-column>
        <el-table-column prop="minUnit" width="100" label="最小单位"></el-table-column>
        <el-table-column prop="price" width="80" label="价格"></el-table-column>
        <el-table-column prop="amount" width="100" label="小计"></el-table-column>
        <el-table-column prop="stockCategoryName" width="90" label="库存类型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validityDate" v-if="query.type==1" :key="'validityDate'" width="120" label="有效期">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
            }}</template>
        </el-table-column>
        <el-table-column prop="longTime" v-if="query.type==1" :key="'longTime'" label="长期"  width="60">
          <template slot-scope="scope">
            {{ scope.row.longTime == 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="batch" v-if="query.type==1" :key="'batch'" width="100" label="批号"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufactureDate" v-if="query.type==1" :key="'manufactureDate'" width="120" label="生产日期">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
            }}</template>
        </el-table-column>
        <el-table-column prop="serialNo" v-if="query.type==1" :key="'serialNo'" width="100"  label="序列号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.serialNo?scope.row.serialNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="mainNo" v-if="query.type==1" :key="'mainNo'" width="150" label="主条码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.mainNo?scope.row.mainNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="traceNo" v-if="query.type==1" :key="'traceNo'" label="溯源码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.traceNo?scope.row.traceNo:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" width="120" label="供应商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
          width="200"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetIntelligenceCounterStocks, ExportRfidStock } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetIntelligenceCounterStocks,
      // RemoveAction: RemoveAcceptOutStock,
      // PrintAction: GetAcceptOutStockPrintData,
      // editPath: 'accept-out-stock-edit',
      exportAction: ExportRfidStock,
      StockCategoryOptions: StockCategoryOptions,
      filterOptions1:[
         {
          name: "智能柜",
          type: "select",
          code: "intelligenceCounterId",
          filterMethod: this.getIntelligenceCounters,
          data: [],
        },
          {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
             {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
         {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
      ],
      filterOptions: [
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "库存类别",
          type: "select",
          code: "stockCategory",
          data: StockCategoryOptions,
        },
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "智能柜",
          type: "select",
          code: "intelligenceCounterId",
          filterMethod: this.getIntelligenceCounters,
          data: [],
        },
        {
          name: "Rfid",
          type: "input",
          code: "rfid",
        },
        
      ],
      CounterStockArray:[
        {
          id:1,
          name:'按标签'
        },
        {
          id:2,
          name:'按产品'
        }
      ]
    };
  },
  methods: {
    tabClick(){
      this.getData()
    }
  },
  mounted() {
    this.query.type = '1'
   },
};
</script>

<style lang="scss" scoped></style>
